import { OrganizerForm } from "components/organizers";

export const CreateOrganizer = () => {
  return <OrganizerForm isNew />;
};
